// 倒入模块

import axios from 'axios'
import Qs from 'qs'
import router from '../router'
import {startLoading, endLoading } from '../pages/config/serviceLoading'
import {
  Message
} from 'element-ui'
import {
  cookieStorage
} from '../common/storage'
import Vue from 'vue'
Vue.prototype.$axios = axios
export default function fetch (options, config) {
  // var baseURLStr = window.g.SERVICE_CONTEXT_PATH;
  // let time = new Date().getTime() / 1000;
  // let expiresTime = cookieStorage.get("expiresTime");

  // //只有十分钟要过期了，重新获取
  // if (time >= expiresTime - 600 && time < expiresTime) {
  //   new Promise((resolve, reject) => {
  //     //创建一个axios实例
  //     const instance = axios.create({
  //       //设置默认根地址
  //       baseURL: "/chnapi",
  //       timeout: 20000,
  //       headers: {
  //         Authorization: JSON.stringify(cookieStorage.get("domainToken")) === "{}" ?
  //           "" : cookieStorage.get("domainTokenType") + " " + cookieStorage.get("domainToken")
  //       }
  //     });
  //     instance.interceptors.response.use(
  //       response => {
  //         return response;
  //       },
  //       error => {
  //         if (error.message.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
  //           Message.error('服务器繁忙，请检查后再试')
  //           return Promise.reject(error);
  //         } else if (error.message.includes(401)) {
  //           Message.error('登录超时，请重新登录')
  //           cookieStorage.remove("domainisLogin");
  //           cookieStorage.remove("domainTokenType");
  //           cookieStorage.remove("domainToken");
  //           router.replace({
  //             path: '/HomeSearch'
  //           })
  //           return Promise.reject(error);
  //         } else {
  //           return Promise.reject(error);
  //         }
  //       });
  //     //请求处理
  //     instance({
  //         url: '/SMUsers/UpdateToken',
  //         method: 'get'
  //       })
  //       .then(({
  //         data: {
  //           code,
  //           msg,
  //           data,
  //           total,
  //           isSuccess
  //         }
  //       }) => {
  //         //请求成功时，
  //         if (code == 200) {
  //           cookieStorage.set('expiresTime', data.profile.expiresTime);
  //           cookieStorage.set('domainToken', data.token);
  //         }
  //       })
  //       .catch(error => {
  //         //请求失败时，根据业务判断状态
  //         if (error.response) {}
  //       });
  //   });
  // }
  // console.log('options', options)
  // console.log('3333', config)
  if (options.cancelToken && config && config.cancelTokenSource) {
    console.log('2222')
    options.cancelToken = config.cancelTokenSource.token // 如果传入了 cancelTokenSource，则将 cancelToken 设置到 options 中
  } else if (config && config.cancelTokenSource) {
    console.log('1111')
    options.cancelToken = new axios.CancelToken(c => {
      // 将取消函数保存起来以便后续调用
      config.cancelTokenSource.cancel = c
    })
  }
  return new Promise((resolve, reject) => {
    // 创建一个axios实例
    const instance = axios.create({
      // 设置默认根地址
      // baseURL:baseURLStr,
      // baseURL:'http://192.168.18.74:8080/domainSystem/',
      // baseURL:'http://192.168.18.130:8080/domainSystem/',
      // baseURL: '/chnapi',
      baseURL: window.serverConfig.serverList.server1.baseUrl || '/api',
      // baseURL: "http://192.168.18.72:19111/",
      // jenkis测试写死
      timeout: 120000,
      headers: {
        token: cookieStorage.get('domainToken')
        // Authorization: JSON.stringify(cookieStorage.get('domainToken')) === '{}'
        //   ? '' : cookieStorage.get('domainTokenType') + ' ' + cookieStorage.get('domainToken')
      }
      // withCredentials:true,
      // transformRequest: [function (data) {
      //   data = Qs.stringify(data);
      //   return data;
      // }],
    })
    if (config && config.noLoad) {

    } else {
      console.log('12313', options)
      startLoading()
    }
    instance.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.message.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
          Message.error('服务器繁忙，请检查后再试')
          return Promise.reject(error)
        } else if (error.message.includes(511)) {
          Message.error('登录超时，请重新登录')
          cookieStorage.remove('domainisLogin')
          cookieStorage.remove('domainTokenType')
          cookieStorage.remove('domainToken')
          Vue.prototype.router.replace({
            path: '/HomeSearch'
          })
          return Promise.reject(error)
        } else {
          return Promise.reject(error)
        }
      })

    console.log(options)

    if (options.responseType == 'blob') {
      instance(options)
        .then((res) => { resolve(res); endLoading() })
        .catch((err) => {
          console.log(err)
          if (config && config.noLoad) {

          } else {
            endLoading()
          }
        })
      return
    }

    // 请求处理
    instance(options)
      .then(({
        data: {
          code,
          msg,
          data,
          total,
          isSuccess
        }
      }) => {
        console.log(data)
        if (config && config.noLoad) {

        } else {
          endLoading()
        }
        // 请求成功时，
        if (code == 200) {
          // console.log(data);
          resolve({
            code,
            msg,
            data,
            total
          })
          // setTimeout(() => {
          //   resolve({
          //     code,
          //     msg,
          //     data,
          //     total
          //   })
          // }, 5000)

          return false
        } else if (code == 511) {
          Message.error('登录超时，请重新登录')
          cookieStorage.remove('domainisLogin')
          cookieStorage.remove('domainToken')
          cookieStorage.remove('domainTokenType')
          // this.$router.push({
          //   path: '/'
          // })
          Vue.prototype.router.replace({
            path: '/HomeSearch'
          })
        } else if (code == 201) {
          resolve({
            code,
            msg,
            data,
            total
          })
          return false
        } else if (code == 404) {
          resolve({
            code,
            msg,
            data,
            total
          })
          return false
        } else if (code == 500) {
          Message.error(msg)
          resolve({
            code,
            msg,
            data,
            total
          })
          return false
        }
        // Message.error(msg)
        resolve({
          code,
          msg,
          data,
          total
        })
      })
      .catch(error => {
        // 请求失败时，根据业务判断状态
        if (config && config.noLoad) {

        } else {
          endLoading()
        }
        if (error.response) {
          let resError = error.response
          let resCode = resError.status
          let resMsg = error.message
          if (resMsg.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
            reject({
              code: resCode,
              msg: resMsg
            })
          } else if (resMsg.includes(401)) {
            reject({
              code: resCode,
              msg: resMsg
            })
          } else {
            Message.error('操作失败！错误原因' + resMsg)
            reject({
              code: resCode,
              msg: resMsg
            })
          }
        } else {
          reject({
            code: 500,
            msg: '123'
          })
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/fetch/index.js